import * as angular from 'angular';

import { PercentageEvolutionWidgetBase } from './percentageEvolutionBase.widget';
import { IInputValuesService, IExportToCsvService } from '../../services';
import { IWidgetConfiguration } from '../';

export class PercentageOfGoodValuesEvolutionWidget extends PercentageEvolutionWidgetBase {
    name = 'Trend of the percentage of good values';
    type = 'percentageOfGoodValuesEvolution';
    highlights = ['A trend of the percentage of good values over time'];

    constructor(private _inputValuesService: IInputValuesService,
        private _exportToCsvService: IExportToCsvService,
        config?: IWidgetConfiguration) {

        super(config);
    }

    readData(guid?: string): angular.IPromise<any> {
        return this._inputValuesService.getPercentageOfGoodValuesPerDate(guid);
    }

    exportToCsv(guid?: string): angular.IPromise<any> {
        return this._exportToCsvService.getCsvPercentageGoodValuesPerDate(this.name, guid);
    }
}